export const CLASS_OT_AMAZON_DISCOUNT = 'ot_amazon_discount'
export const CLASS_OT_CHARGE = 'ot_charge'
export const CLASS_OT_CUSTOM = 'ot_custom'
export const CLASS_OT_DISCOUNT = 'ot_discount'
export const CLASS_OT_LEV_DISCOUNT = 'ot_lev_discount'
export const CLASS_OT_NON_DISCOUNT = 'ot_non_discount'
export const CLASS_OT_PAYMENT = 'ot_payment'
export const CLASS_OT_PREORDER_LEV_DISCOUNT = 'ot_preorder_lev_discount'
export const CLASS_OT_SHIPPING = 'ot_shipping'
export const CLASS_OT_SHIPPING_DISCOUNT = 'ot_shipping_discount'
export const CLASS_OT_SUBTOTAL = 'ot_subtotal'
export const CLASS_OT_SURCHARGE = 'ot_surcharge'
export const CLASS_OT_TAX = 'ot_tax'
export const CLASS_OT_TOTAL = 'ot_total'

export const TITLE_SUB_TOTAL = 'Sub-Total'
export const TITLE_TOTAL = 'Total'
export const TITLE_SALES_TAX = 'Sales Tax'
export const TITLE_NON_DISCOUNT_SUB_TOTAL = 'Non-Discountable Sub-Total'
export const TITLE_ADDITIONAL_CHARGES = 'Additional Charges'
export const TITLE_SHIPPING = 'Shipping'
export const TITLE_SHIPPING_DISCOUNT = 'Shipping Discount'
export const TITLE_CREDIT_DEBIT_FEE = 'Card Processing Fee'
